var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "article--excerpt-wrapper" }, [
    _c("article", { staticClass: "article-list-item" }, [
      _c(
        "a",
        {
          staticClass: "article--excerpt-image",
          class: { "is-event": _vm.meta === "Event" },
          style: "background-image: url(" + _vm.sizedImageSrc + ");",
          attrs: { href: _vm.url }
        },
        [
          _c("img", {
            attrs: {
              src: _vm.sizedImageSrc,
              alt: _vm.title,
              srcset: _vm.sizedImageSrc
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "article--excerpt-content" }, [
        _c("div", { staticClass: "article--excerpt-meta" }, [
          _c("span", { staticClass: "article--excerpt-meta-item" }, [
            _vm._v(" " + _vm._s(_vm.meta) + ": ")
          ])
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "article--excerpt-title" }, [
          _c("a", { attrs: { href: _vm.url } }, [
            _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")
          ])
        ]),
        _vm._v(" "),
        _vm.canShowPublishedDate
          ? _c(
              "span",
              { staticClass: "article--excerpt-meta-item published-date" },
              [_vm._v("\n        " + _vm._s(_vm.publishedDate) + "\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "article--excerpt-text rte" }, [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.excerpt) } })
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "article--excerpt-readmore",
            attrs: { href: _vm.url, "aria-label": _vm.readMoreLabel }
          },
          [_vm._v("\n        " + _vm._s(_vm.readMoreLabel) + "\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }